import { Injectable, inject } from '@angular/core';
import { ICorrelationCriteriaDTO } from '../dto/correlation.criteria.dto';
import { ICorrelationModel } from '../model/correlation.model';
import { Observable } from 'rxjs';
import { ENV_CONFIG, EnvironmentConfig } from '@libs/vc-core-lib';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class CorrelationService {
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _serviceBaseUrl: string = 'correlations';

    public get(id: number): Observable<ICorrelationModel> {
        return this._httpClient.get<ICorrelationModel>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._serviceBaseUrl}/${id}`
        );
    }

    public searchWithoutPaging(correlationCriteria: ICorrelationCriteriaDTO): Observable<Array<ICorrelationModel>> {
        return this._httpClient.post<Array<ICorrelationModel>>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._serviceBaseUrl}/search`,
            correlationCriteria
        );
    }

    public upsert(correlation: ICorrelationModel): Observable<ICorrelationModel> {
        return this._httpClient.post<ICorrelationModel>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._serviceBaseUrl}`,
            correlation
        );
    }

    public delete(id: number): Observable<void> {
        return this._httpClient.delete<void>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._serviceBaseUrl}/${id}`
        );
    }
}
